import React, { Component } from 'react'

class CheckBoxFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: props.checked
    }
    this.checkBox = React.createRef()
  }

	handleToggle = () => {
	  this.props.fn(this.checkBox.current.checked)
	}

	componentDidMount() {
	  this.checkBox.current.checked = this.state.checked
	}

	render() {
	  return (
	    <label>
	      <input ref={this.checkBox} type="checkbox" onChange={this.handleToggle} /> {this.props.label}
	    </label>
	  )
	}
}

export default CheckBoxFilter



// WEBPACK FOOTER //
// ./src/modules/Filters/CheckBoxFilter/CheckBoxFilter.jsx